/*
 * LocalStorage.js
 *
 * Functions for saving, loading and checking local storage
 */

/*
 * Constructor for Local Save System
 * Wrapper object for the local storage object
 */
function LocalSaveSystem () {

}

/*
 * Initialise any main local storage items
 */
LocalSaveSystem.prototype.InitialiseLocalData = function () {
}

/*
 * Checks if a local storage item exists
 */
LocalSaveSystem.prototype.HasLocalStorageItem = function (p_item_name) {
  if (localStorage[p_item_name] === undefined || localStorage[p_item_name] === null) {
    return false;
  }

	return true;
};

/*
 * Retrieves an item from local storage
 */

LocalSaveSystem.prototype.GetLocalStorageItem = function (p_item_name) {
	if (localStorage.getItem(p_item_name) === undefined || localStorage[p_item_name] === null) {

		var msg = 'Item ' + p_item_name + ' does not exist in local storage. Ignoring ';
		VRC.ConfirmationModal.show({msg: msg, type: 'alert'});
	}
	try {
		var l_obj = localStorage.getItem(p_item_name)

		return JSON.parse(l_obj);

	}
	catch (e) {

		return l_obj;
	}
}

/*
 * Sets a local storage item
 */
LocalSaveSystem.prototype.SetLocalStorageItem = function (p_name, p_value) {
	try {
		localStorage.setItem(p_name, JSON.stringify(p_value));
	}
	catch (l_exception) {
		if (l_exception == QUOTA_EXCEEDED_ERRPR) {
			var msg = 'Max allowed storage space exceeded. Could not store (all) items in local storage';

			VRC.ConfirmationModal.show({msg: msg, type: 'alert'});
			VRC.ErrorHandleService.showMessage('Max allowed storage space exceeded. Could not store (all) items in local storage', G_MSG_TYPE_ERROR);
			console.error(e.stack); //Added to get debug info in production
		}
		else {
			var msg = 'An error occured whilst trying to save to local storage. Exception: ' + l_exception;
			VRC.ConfirmationModal.show({msg: msg, type: 'alert'});
			VRC.ErrorHandleService.showMessage('An error occured whilst trying to save to local storage. Exception: ' + l_exception, G_MSG_TYPE_ERROR);
			console.error(e.stack); //Added to get debug info in production
		}
	}
}

/*
 * Deletes local storage item
 */
LocalSaveSystem.prototype.RemoveLocalStorageItem = function (p_name) {
	if (localStorage.getItem(p_name) === undefined || localStorage[p_name] === null) {
		var msg = 'Item ' + p_name + ' does not exist in local storage. Ignoring ';
		VRC.ConfirmationModal.show({msg: msg, type: 'alert'});
	}
	try {
		localStorage.removeItem(p_name)
	}
	catch (e) {
		var msg = ' Error deleting ' + p_name + ' from local storage ';
		VRC.ConfirmationModal.show({msg: msg, type: 'alert'});
		VRC.ErrorHandleService.showMessage(' Error deleting ' + p_name + ' from local storage ', G_MSG_TYPE_ERROR);
		console.error(e.stack); //Added to get debug info in production
	}
}

/*
 * Prints out all data to a webpage
 */
LocalSaveSystem.prototype.PrintLocalStorageData = function () {
	var l_output;
	try {
		for (var l_key in localStorage) {
			var l_data = '';
			try {
				l_data = this.GetLocalStorageItem(l_key);
				l_output += '<div><h2>' + l_key + '</h2><p>' + JSON.stringify(l_data) + '</p></div>';
			}
			catch (l_err) {
				l_data = localStorage[l_key];
				l_output += '<div><h2>' + l_key + '</h2><p>' + l_data + '</p></div>';
			}

		}
		return l_output;
	}
	catch (l_err) {

	}
}

/*
 * Loads local state.
 */
function LoadLocalState () {
	try {
		// Load master data from local storage
		g_master_data.LoadMasterData();

		// Populate data again
		g_data_list = g_localsave_object.GetLocalStorageItem(G_LS_NAMES['MAIN_VESSEL_DATA']);

	}
	catch (l_err) {
		VRC.ErrorHandleService.showMessage('An error occured whilst trying to load local data: ' + l_err, G_MSG_TYPE_ERROR);
		console.error(l_err.stack); //Added to get debug info in production
	}
}

/*
 * Saves local state ( containers, deck and vessel/rig data
 */
function SaveLocalState () {
	try {
		g_localsave_object.SetLocalStorageItem(G_LS_NAMES['DECK_CONTAINER_DATA'], g_container_list);
		g_localsave_object.SetLocalStorageItem(G_LS_NAMES['MAIN_VESSEL_DATA'], g_data_list);
		VRC.ErrorHandleService.showMessage('Succesfully saved content to local storage', G_MSG_TYPE_SUCCESS);
	}
	catch (l_err) {
		VRC.ErrorHandleService.showMessage('An error occured whilst trying to save local data: ' + l_err, G_MSG_TYPE_ERROR);
		console.error(l_err.stack); //Added to get debug info in production
	}
}
